module.exports = __webpack_public_path__ + "img/smarcle.4201b16e.png";